import { Col, Form, Row } from "react-bootstrap";

interface IEpaFieldHtml2 {
  label: string;
  element: JSX.Element;
  labelClassName?: string;
  valueClassName?: string;
}

export const EpaFieldHtml2 = ({
  label,
  element,
  labelClassName,
  valueClassName,
}: IEpaFieldHtml2) => {
  if (!labelClassName) labelClassName = "col-4 col-md-4";

  if (!valueClassName) valueClassName = "col-8 col-md-8";

  return (
    <Row>
      <Col className={labelClassName}>
        <Form.Label>{label}</Form.Label>
      </Col>
      <Col className={valueClassName}>{element}</Col>
    </Row>
  );
};
